<!-- サブスクリプションの自動更新解除ボタン -->
<!-- Organisms(Dialog)を呼び出しているので単体テスト不可。一旦stortbookなし -->
<template>
  <li>
    <a @click="openDialog"> チケット有効期間の自動更新を停止する </a>

    <DialogStopSubscriptionDialog ref="DialogStopSubscriptionDialog" />
  </li>
</template>

<script>
import DialogStopSubscriptionDialog from "@/views/Components/Organisms/MyTickets/Dialog/DialogStopSubscriptionDialog";

export default {
  name: "BFaceStopSubscriptionButton",
  components: {
    DialogStopSubscriptionDialog: DialogStopSubscriptionDialog,
  },
  methods: {
    openDialog() {
      this.$refs.DialogStopSubscriptionDialog.openDialog();
    },
    closeDialog() {
      this.$refs.DialogStopSubscriptionDialog.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped></style>
